export default __webpack_public_path__ + "static/media/icon.2e98b699.svg";